<template>
  <section id="feature">
    <v-container class="container-fluid pb24">
        <div class="w0 h1 bgc-orange mt40 posa l0 line-w" style="transition: width 1s ease; transform-origin: left 50% 0px; visibility: inherit; opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);"></div>
        <v-row class="fill-height">
            <v-col cols="12" class="col-lg-12">
                <h2 class="tac fw600">Recent <span class="">Posts</span></h2>
            </v-col>
        </v-row>
        <v-row justify="center" class="fill-height">
        <!-- featured card -->
          <v-col 
            v-for="post in featured"
            :key="post.id"
            cols="10"
            class="col-sm-4 col-md-4 tal mih125@md featured-posts"
          >
            <featuredcard
              :post="post"
            />

          </v-col>
        </v-row>
    </v-container>
  </section>
</template>

<style scoped>

</style>

<script>
import moment from 'moment';
import featuredcard from './partials/featured-material-card'

  export default {
    components: {
      featuredcard,
    },

    data() {
      return {
        featured: [],
        message: 'none'
      }
    },
    created: function() {
      this.getContent();
    },
    filters: {
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      },
      fixDate: function (value) {
        let date;
        let f = 'MMMM Do, YYYY';
        date = moment(value).format(f);
        return date
      }
    },

    methods: {
      getContent () {
      this.$prismic.client.query(
        this.$prismic.Predicates.at("document.type", "post"),
          { page: 1, pageSize: 3, orderings: '[my.post.date desc]', fetch : ['post.date', 'post.title', 'post.media', 'post.slugs', 'post.description', 'post.categories'] }
      ).then((response) => {
        // response is the response object, response.results holds the documents
        // this.message = response.results;

        response.results.forEach(returnedPost => {
          let cats = [];
          let i=0;
          returnedPost.data.categories.forEach(linkedCategories => {
            // categories.push({slug: linkedCategories.category.slug, href: "/blog/" + linkedCategories.category.slug, id: i});
            cats.push({id: i, slug: linkedCategories.category.slug});
            i++
          });

          this.featured.push(
            {
              id: returnedPost.id,
              uid: returnedPost.uid,
              title: returnedPost.data.title[0].text,
              desc: returnedPost.data.description[0].text,
              date: returnedPost.data.date,
              media: returnedPost.data.media.url,
              // id: returnedPost.uid,
              categories: cats
            }
          )
          
        });
      });
    }
    }
  }
</script>